/**
 * Licensed Materials - Property of IBM
 * IBM Watson (C) Copyright IBM Corp. 2018, 2020
 * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Label } from '@ba/ba-ui-carbon-toolkit';
import StringResources from './nls/StringResources';
import VisualizationPreviewList from './preview/VisualizationPreviewList';
import { ProgressIndicator } from '@ba/ba-ui-carbon-toolkit';
import { observer } from 'mobx-react';
import classnames from 'classnames';

import './recommendedCommon.scss';

@observer
class RecommendedCommon extends Component {
	constructor(props) {
		super(props);
	}

	render() {
		const classes = classnames(this.props.className, 'vis-recommendation-common');

		return (
			<div className={classes}>
				{this.renderContent()}
			</div>
		);
	}

	renderContent() {
		switch (this.props.recommendationVM.state) {
			case 'done':
				return this.renderPreviewList();
			case 'pending':
				return (
					<div className="vis-recommendation-common__progress-indicator-container">
						<ProgressIndicator />
					</div>
				);
			case 'error':
				return this.renderMessage(StringResources.get('widget_recommender_fail'));
		}
	}

	renderPreviewList() {
		let { recommendationVM, ...other } = this.props;

		if (this._hasRecommendation()) {
			return (
				<VisualizationPreviewList
					isVizTypeLocked= {this.props.isVizTypeLocked}
					recommendationFilter = {this.props.recommendationFilter}
					selectedVisId= {this.props.selectedVisId}
					onPromptingError={this.props.onPromptingError}
					{...other}
					horizontal={true}
					items={recommendationVM.getRecommendations()}
					titleOnBottom={false}
					logger={this.props.logger}
					isNewLayoutEnabled={this.props.recommendationVM.getNewLayoutEnabled()}
				/>
			);
		}

		return this.renderMessage(StringResources.get('widget_recommender_fail'));
	}

	renderMessage(message) {
		return (
			<div className="vis-recommendation-common__recommender-message">
				<Label label={message} />
			</div>
		);
	}

	_hasRecommendation() {
		let { recommendationVM } = this.props;
		const recommendations = recommendationVM.getRecommendations();
		return !!(recommendations && recommendations.length > 0);
	}

}

RecommendedCommon.propTypes = {
	dashboardApi: PropTypes.object.isRequired,
	onClickItem: PropTypes.func,
	recommendationVM: PropTypes.object.isRequired,
	enableSeeMore: PropTypes.bool,
	maxDisplayedItems: PropTypes.number,
	className: PropTypes.string,
	isVizTypeLocked: PropTypes.bool,
	recommendationFilter: PropTypes.string,
	selectedVisId: PropTypes.string,
	additionalProperties: PropTypes.arrayOf(PropTypes.object),
	logger: PropTypes.object,
	onPromptingError: PropTypes.func
};
RecommendedCommon.defaultProps = {
	onClickItem: () => {},
	additionalProperties: []
};
export default RecommendedCommon;



// WEBPACK FOOTER //
// ./src/js/lib/@waca/vis-recommender/src/js/RecommendedCommon.js